
import React, { useState } from 'react';

import Header from '../Components/Header';
import Updates from '../Components/Updates';
import Pictures from '../Components/Pictures';

const Eleanor = ({ }) => {

    let currentApp = 'None';

    const updatesHeight = {
        'None': '45%',
        'Updates': '80%',
        'Pictures': '0%'
    }
    const picturesHeight = {
        'None': '40%',
        'Updates': '0%',
        'Pictures': '80%'
    }


    return (
        <div 
        className='ellas-corner-container'
        >

            <div className='eleanor-background' />

            <Header
            title={"Ella's Corner"}
            page={"Eleanor"}/>

            <div
            style={{
                minHeight: '8%',
                width: '100%',
            }} />

            <div 
            style={{
                height: updatesHeight[currentApp],
                width: '100%',
            }}>
                <Updates title={'Updates'} app={'eleanor'}/>
            </div>


            <div 
            style={{
                height: picturesHeight[currentApp],
                width: '100%',
            }}>
                <Pictures title={"Art Gallery"} app={'eleanor'}/>
                

            </div>
            
        </div>
    )


};

export default Eleanor;